/**
 * 契約一覧・契約詳細の画面の大きさ。AppLayout の disableContentPadding と組み合わせて使う。
 *
 * 行が多くても、見出しの行と操作の欄を見えたままにするため、画面を表示領域の幅と高さに収め、表の値の行だけをスクロールする。
 * 画面が大きいほど、表に多くの行と列が見える。表示領域が低すぎるときは、表が潰れないよう最小の高さを置き、ページをスクロールする。
 */
export const fillViewportSx = {
  boxSizing: 'border-box',
  height: 'calc(100vh - var(--app-header-h))',
  minHeight: 480,
  px: 2,
  py: 1.5,
} as const;
